import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Building2, Search, MapPin, Mail, Phone } from "lucide-react";

export default function CustomerFindBusiness() {
  const [q, setQ] = useState("");
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = (query) => {
    setLoading(true);
    api.get("/customer/companies", { params: query ? { q: query } : {} })
      .then((r) => setItems(r.data))
      .finally(() => setLoading(false));
  };

  useEffect(() => { load(""); }, []);

  const onSubmit = (e) => { e.preventDefault(); load(q); };

  return (
    <div className="space-y-6" data-testid="portal-find-page">
      <div>
        <h1 className="font-display text-3xl sm:text-4xl font-bold">Find a Business</h1>
        <p className="text-slate-600 mt-1">Directory of rental businesses using ConfirmPH.</p>
      </div>

      <form onSubmit={onSubmit} className="flex items-center gap-2">
        <div className="relative flex-1 max-w-md">
          <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
          <input
            data-testid="portal-find-search"
            value={q} onChange={(e) => setQ(e.target.value)}
            placeholder="Search by business name or city…"
            className="pl-9 pr-3 py-2 w-full rounded-lg border border-slate-300 bg-white outline-none focus:border-[#2D6A4F] text-sm"
          />
        </div>
        <button
          type="submit"
          data-testid="portal-find-search-btn"
          className="px-4 py-2 rounded-lg btn-brand text-sm font-medium"
        >
          Search
        </button>
      </form>

      {loading && <div className="text-slate-500">Loading…</div>}
      {!loading && items.length === 0 && (
        <div className="rounded-xl border border-dashed border-slate-300 bg-white p-10 text-center text-slate-500" data-testid="portal-find-empty">
          <Building2 className="w-8 h-8 mx-auto text-slate-400" />
          <p className="mt-2">No businesses match your search.</p>
        </div>
      )}

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {items.map((c) => (
          <div key={c.id} className="rounded-xl border border-slate-200 bg-white p-5" data-testid={`portal-business-${c.id}`}>
            <div className="flex items-start gap-2">
              <div className="w-10 h-10 rounded-lg bg-[#1B4332]/10 text-[#1B4332] grid place-items-center">
                <Building2 className="w-5 h-5" />
              </div>
              <div className="min-w-0">
                <h3 className="font-display text-lg font-semibold">{c.name}</h3>
                <div className="text-xs text-slate-500">{c.business_type?.replace(/_/g, " ")}</div>
              </div>
            </div>
            <dl className="mt-4 space-y-1 text-sm text-slate-700">
              {c.city && <div className="inline-flex items-center gap-2"><MapPin className="w-3.5 h-3.5 text-slate-400" /> {c.city}</div>}
              {c.email && <div className="inline-flex items-center gap-2"><Mail className="w-3.5 h-3.5 text-slate-400" /> {c.email}</div>}
              {c.phone && <div className="inline-flex items-center gap-2"><Phone className="w-3.5 h-3.5 text-slate-400" /> {c.phone}</div>}
            </dl>
          </div>
        ))}
      </div>
    </div>
  );
}
